// extracted by mini-css-extract-plugin
export default {"homeBodyWrapper":"Home_homeBodyWrapper__--jhF","homeHeader":"Home_homeHeader__io-l+","homeMain":"Home_homeMain__blsJw","homeSection":"Home_homeSection__tYzFB"};